var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-popup',{attrs:{"close-on-click-overlay":false},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('van-loading',{attrs:{"size":"40","color":"#fff"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }